"use strict";

import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
const _excluded = ["children", "fallback", "errorFallback", "onError"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { ENV_NAME } from '@autoguru/global-configs';
import { logException, useLoggingAgent } from '@autoguru/logs';
import { Suspense, useCallback } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { AsyncFallback } from '../AsyncFallback';
import { ErrorFallback } from '../ErrorFallback';
import { jsx as _jsx } from "react/jsx-runtime";
const logError = (error, info, agent) => logException(error, {
  react: {
    componentStack: info === null || info === void 0 ? void 0 : info.componentStack
  }
}, agent);
const FallbackSpinner = /*#__PURE__*/_jsx(AsyncFallback, {});
export const AsyncBoundary = _ref => {
  let {
      children,
      fallback = FallbackSpinner,
      errorFallback: ErrorFallbackElement,
      onError: incomingOnError
    } = _ref,
    suspenseProps = _objectWithoutProperties(_ref, _excluded);
  const agent = useLoggingAgent();
  const actionOnError = (error, info) => {
    logError(error, info, agent);
    if (typeof incomingOnError === 'function') incomingOnError(error, info);
  };
  const fallbackRender = useCallback(({
    error,
    resetErrorBoundary
  }) => /*#__PURE__*/_jsx(ErrorFallback, {
    error: error,
    hideDetails: ENV_NAME === 'prod',
    resetErrorBoundary: resetErrorBoundary
  }), []);
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    onError: actionOnError,
    fallbackRender: ErrorFallbackElement ? () => ErrorFallbackElement : fallbackRender,
    children: /*#__PURE__*/_jsx(Suspense, _objectSpread(_objectSpread({}, suspenseProps), {}, {
      fallback: fallback,
      children: children
    }))
  });
};